module.exports = __webpack_public_path__ + "static/media/popsicle-screenshot-4.e875e94d.png";